import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Button from '../buttons/Button';
import Dialog from './Dialog';
import Modal from './Modal';

import styles from '../../../styles/modals/video-modal.module.scss';

const propTypes = {
    video: AppPropTypes.video,
    closesOnEnded: PropTypes.bool,
    allowCloseOnEnded: PropTypes.bool,
    delay: PropTypes.number,
    onClose: PropTypes.func,
    onEnded: PropTypes.func,
};

const defaultProps = {
    video: null,
    closesOnEnded: false,
    allowCloseOnEnded: false,
    delay: null,
    onClose: null,
    onEnded: null,
};

const VideoModal = ({ video, closesOnEnded, allowCloseOnEnded, delay, onClose, onEnded }) => {
    const [opened, setOpened] = useState(true);
    const [ended, setEnded] = useState(false);
    const canClose = (allowCloseOnEnded && ended) || !allowCloseOnEnded;

    const onRequestClose = useCallback(() => {
        setOpened(false);
    }, []);

    const onVideoEnded = useCallback(() => {
        if (closesOnEnded) {
            if (delay !== null) {
                setTimeout(onRequestClose, delay);
            } else {
                onRequestClose();
            }
        }
        if (onEnded !== null) {
            onEnded();
        }
        setEnded(true);
    }, [closesOnEnded, onRequestClose, onEnded, setEnded]);

    return (
        <Modal withSafe onClickSafe={canClose ? onClose : null} opened={opened} onClosed={onClose}>
            <Dialog withCloseButton={canClose} onClickClose={canClose ? onRequestClose : null}>
                <Button onClick={onClose}>
                    <video
                        className={styles.video}
                        preload="auto"
                        muted
                        playsInline
                        autoPlay
                        onEnded={onVideoEnded}
                    >
                        <source src={`${video.mp4}#t=0.1`} type="video/mp4" />
                        <source src={`${video.webm}#t=0.1`} type="video/webm" />
                    </video>
                </Button>
            </Dialog>
        </Modal>
    );
};

VideoModal.propTypes = propTypes;
VideoModal.defaultProps = defaultProps;

export default VideoModal;
